export default class AdministrativeFilesIndex {

    constructor() {
        this.validation = null;
        this.validation_password = null;
        this.bindEvents();
        this.init();
        //window.application.setOnDataChangeListener(this);
    }

    init() {
      $.validator.addMethod("phone_number_fr", function(value, element) {
          let val = value.replace(/ /g, '');
          return val.match(/[0-9]/g) && value.replace(/ /g, '').length === 10 && (value.charAt(0) === "0");
      }, I18n.t('common.js_validation.phone_number_fr'));
  
      $.validator.addMethod("password_validation", function(value, element) {
          return value.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,70}$/g) && value.length >= 8;
      }, I18n.t('common.js_validation.password_validation'));

      $.validator.addMethod("neph_number_validation", function(value, element) {
        if (value === "") {
            return true;
        }
        return /^[A-Z0-9]{12}$/i.test(value);
      }, I18n.t('common.js_validation.neph_number_validation'));
   
      this.validation_personal_information();
      this.validation_change_password();
  
      let hash = location.hash.replace(/^#/, '');
      if (hash) {
          $('.files-nav a[href="#' + hash + '"]').tab('show');
      }
  
      /*$('.files-nav a').on('shown.bs.tab', function (e) {
          window.location.hash = e.target.hash;
      })*/
    }

    bindEvents() {
        let self = this;
        $("#profile_image_input").change(function (){
            
        });

        $(document).ready(function (){
            self.validation.form();
        })

        $("#customer_instructor_description").keyup(function (){
            let length = $(this).val().length
            let label = $(this).next("label")
            if(length >= 1200){
                label.addClass("text-danger")
            }else{
                label.removeClass("text-danger")
            }
            label.text(I18n.t("monitors.administrative_files.personal_info.description", {number: length}))
        });

        $('.upload_file').click(this.openUpload);

        $("input[id^=id_file_]").change(this.handleDocs);

        $(".js-ephoto").click(this.sendEphoto);

        $('#customer_birth_date').change(function (){
            if(moment($(this).val(), "DD/MM/YYYY").isAfter(moment().subtract(18, 'years'))){
                $('.js-legal_responsible').removeClass('d-none');
            }else{
                $('.js-legal_responsible').addClass('d-none');
                self.validation_personal_information();
            }
        })

        $('#customer_address_postal_code').select2({
            minimumInputLength: 1,
            ajax: {
                contentType: "application/json",
                delay: 250,
                url: $('#customer_address_postal_code').data('url'),
                dataType: 'json',
                transport: function (params, success, failure) {
                    params['contentType'] = "application/json";
                    let $request = $.ajax(params);

                    $request.then(success);
                    $request.fail(failure);

                    return $request;
                }
            },
            theme: 'bootstrap'
        });

        $('label[for=customer_address_postal_code]').click(() => {
            $('#customer_address_postal_code').select2('open');
        })

        $(document).on('select2:open', () => {
            document.querySelector('.select2-search__field').focus();
        });

        $('#profile_image_input').on('change', function(event) {
          const file = event.target.files[0];
          if (file && self.handleFiles(this.files)) {
            const reader = new FileReader();
            reader.onload = function(e) {
              $('#profile_image_preview').attr('src', e.target.result);
            }
            reader.readAsDataURL(file);
          }
        });

        $('#profile_image_input').on('change', function(event) {
          const file = event.target.files[0];
          var url = $(this).data('url'); 

          if (file && self.valid_file(file)) {
            const formData = new FormData();
            formData.append('customer[profile_image]', file);

            $.ajax({
              url: url,
              type: 'PATCH',
              data: formData,
              contentType: false,
              processData: false,
              success: function(response) {
                if (response.success) {
                  $('#profile_image_preview').attr('src', response.image_url);
                  application.successNotification('Photo mise à jour avec succès.');
                } else {
                  application.errorNotification('Une erreur est survenue lors de la mise à jour de l\'image.');
                }
              },
              error: function(xhr) {
                application.errorNotification('Une erreur est survenue lors de la mise à jour de l\'image.');
              }
            });
          }
        });
    }

    onDataChanged(data) {
    }

    onDestroy() {
    }

    handleFiles(files) {
        let file = files[0]
        if(this.valid_file(file)){
            this.previewFile(file);
        }
    }

    previewFile(file) {
        let reader = new FileReader();

        reader.onload = function(e) {
            $('#profile_image_preview').attr('src', e.target.result);
        }
        //this.file = file;
        reader.readAsDataURL(file); // convert to base64 string
    }

    validation_personal_information() {
        let validate_responsible_fields = moment($('#customer_birth_date').val(), "DD/MM/YYYY").isAfter(moment().subtract(18, 'years'));
        let validation_options = {
            rules: {
                "customer[phone]":{
                    required: true,
                    phone_number_fr: true
                },
                "customer[last_name]":{
                    required: true
                },
                "customer[first_name]":{
                    required: true
                },
                "customer[birth_date]":{
                    required: true
                },
                "customer[birth_place]":{
                    required: true
                },
                "customer[email]":{
                    required: true,
                    email: true
                },
                "customer[address_line1]":{
                    required: true
                },
                "customer[address_city]":{
                    required: true
                },
                "customer[address_postal_code]":{
                    required: true,
                    remote: {
                        url: $('#customer_address_postal_code').data('urlvalidate'),
                        dataType: 'json'
                    },
                },
                "customer[neph_code]":{
                    neph_number_validation: true
                }
            },
            messages:{
                "customer[address_postal_code]": {
                    remote: "Code postal invalide"
                }
            },
            errorClass: 'is-invalid',
            validClass: '',
            errorElement : 'div',
            errorLabelContainer: '.invalid-feedback',
            ignore: [],
            focusInvalid: false,
            invalidHandler: function(form, validator) {

                if (!validator.numberOfInvalids())
                    return;


                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).parent().offset().top - 100
                }, 1000);

            },
            errorPlacement: (error, element) => {
                $(element).parent().append(error);
            }
        }

        Object.assign(validation_options.rules, {
        "customer[responsible_first_name]": {
                required: validate_responsible_fields
            },
            "customer[responsible_last_name]":{
                required: validate_responsible_fields
            },
            "customer[responsible_phone_number]":{
                required: validate_responsible_fields,
                phone_number_fr: validate_responsible_fields
            },
            "customer[responsible_email]":{
                required: validate_responsible_fields,
                email: validate_responsible_fields
            }
        });

        if(I18n.locale !== 'en'){
            validation_options.messages = require("jquery-validation/dist/localization/messages_"+I18n.locale);
        }

        if(this.validation){
            this.validation.destroy();
        }

        this.validation = $("#files_form").validate(validation_options);
    }

    validation_change_password() {

        let validation_options = {
            rules: {
                "customer[current_password]":{
                    required: true
                },
                "customer[password]":{
                    required: true,
                    password_validation: true
                },
                "customer[password_confirmation]":{
                    required: true,
                    equalTo: "#customer_password"
                }
            },
            errorClass: 'is-invalid',
            errorElement : 'div',
            errorLabelContainer: '.invalid-feedback',
            ignore: [],
            focusInvalid: false,
            invalidHandler: function(form, validator) {

                if (!validator.numberOfInvalids())
                    return;


                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).parent().offset().top - 100
                }, 1000);

            }
        }

        if(I18n.locale !== 'en'){
            validation_options.messages = require("jquery-validation/dist/localization/messages_"+I18n.locale);
        }

        this.validation_password = $("#customer_password_form").validate(validation_options);
    }

    openUpload(e) {
        let $el = $(e.currentTarget);
        if(!$el.hasClass('uploaded') && !$el.hasClass('ephoto')){
            $('#'+$el.data('input-id')).click();
        }
    }


    handleDocs(e) {
        let self = application.current_handler;
        let el = e.currentTarget;

        if(el.files[0] !== undefined){
            let id = $(el).data('id');
            let $doc = $('#document_'+id);
            $doc.find('.file-input').addClass('d-none');
            $doc.find('.spinner-border').removeClass('d-none');

            let formData = new FormData();
            formData.append("customer_document[document]", el.files[0]);
            let ajaxData = {
                url: '/administrative_files/'+$(el).data("id")+'/upload_file',
                data : formData,
                method: "POST",
                async: true,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000
            };

            $.ajax(ajaxData)
                .done(function(data) {
                    let $doc = $('#document_'+data['element_id'])
                    $doc.removeClass('file_required').addClass('uploading');
                    $doc.find('.file-input').removeClass('d-none');
                    $doc.find('.spinner-border').addClass('d-none');
                    self.updateBadges();
                    
                    let doc_status = data.doc_status;

                    // update the status tag 
                    $("#doc_status_" + data['element_id']).replaceWith(data.doc_status_tag);

                    // remove refusal reason if it exists
                    $("#document_" + data.element_id).find(".refusal-reason").first().remove();


                    if (doc_status != 'empty' && doc_status != 'error' && doc_status != 'refused') {
                      $("#file_input_" + data['element_id']).addClass('d-none');
                    }

                    application.successNotification("Fichier transmis à l’équipe");
                })
                .fail(function(err) {
                    let data = err.responseJSON;
                    let $doc = $('#document_'+data['element_id']);
                    $doc.addClass('file_required').removeClass('uploading');
                    $('#error_message_'+data['element_id']).text(data['error_message']);
                    $doc.find('.file-input').removeClass('d-none');
                    $doc.find('.spinner-border').addClass('d-none');

                    application.successNotification("Erreur, fichier non transmis à l’équipe");
                });
        }


    }

    updateBadges() {
        let $layout_badge = $('#missing-data-layout');
        let layout_number = parseInt($layout_badge.data('number')) - 1;
        $layout_badge.text(layout_number);

        let $file_badge = $('#files-badge');
        let file_number = parseInt($file_badge.data('number')) - 1;
        $file_badge.text(file_number);
    }

    sendEphoto(e) {
        e.preventDefault();
        let el = e.currentTarget;
        let val = $("#"+$(el).data("input-id")).val();

        if(val.indexOf(' ') === -1 && val.length === 22){
            let ajaxData = {
                url: '/administrative_files/'+$(el).data("id")+'/upload_ephoto',
                data : {customer_document:{extras: {ephoto: val}}},
                method: "POST"
            };

            $.ajax(ajaxData)
                .done(function(data) {
                    $('#document_'+data['element_id']).removeClass('file_required').addClass('uploading');
                    
                    let doc_status = data.doc_status;
                    
                    // update the status tag
                    $("#doc_status_" + data['element_id']).replaceWith(data.doc_status_tag);
                     
                    // remove refusal reason if it exists
                    $("#document_" + data.element_id).find(".refusal-reason").first().remove();

                    if (doc_status != 'empty' && doc_status != 'error') {
                      $("#file_input_" + data['element_id']).addClass('d-none');
                      
                      $("#id_ephoto_file_" + data['element_id']).prop('readonly', true);
                      $("#id_ephoto_file_" + data['element_id']).addClass('bg-light');
                      $("label[for='id_ephoto_file_" + data['element_id'] + "']").hide();
                      $("#id_ephoto_file_" + data['element_id']).closest('div.form-floating').removeClass('form-floating');
                    }

                    $('#error_message_'+$(el).data("id")).text('');

                    application.successNotification("E-Photo transmise à l’équipe");
                })
                .fail(function(err) {
                    let data = err.responseJSON;
                    $('#document_'+data['element_id']).addClass('file_required').removeClass('uploading');
                    $('#error_message_'+data['element_id']).text(data['error_message']);
                });
        }else{
            $('#document_'+$(el).data("id")).addClass('file_required').removeClass('uploading');
            $('#error_message_'+$(el).data("id")).text(I18n.t('students.administrative_files.file_item.ephoto_error'));
        }
    }

    valid_file(file) {
      const allowedTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
          $("#profile_image_error").remove();
          $(".personal-info-container")
              .css('border', '2px solid red')
              .after(
                  `<div id="profile_image_error">
                      ${I18n.t('students.administrative_files.personal_info.invalid_image_format', { formats: 'JPG, JPEG, PNG' })}
                  </div>`
              );
          return false;
      }
      // Remove error message and border if file is valid
      $("#profile_image_error").remove();
      $(".personal-info-container").css('border', '');
      return true;
    }
}